import React from 'react';
import { ArrowLeft, BookOpen, FileText } from 'lucide-react';

const DocxViewer = ({ document, htmlContent, loading, onBack }) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <FileText className="w-12 h-12 text-blue-500 animate-pulse mx-auto mb-2" />
          <p className="text-slate-600">Загрузка документа...</p>
        </div>
      </div>
    );
  }

  if (!document || !htmlContent) {
    return (
      <div className="text-center py-12">
        <FileText className="w-16 h-16 text-slate-300 mx-auto mb-4" />
        <p className="text-slate-600 text-lg">Документ не найден</p>
        <button
          onClick={onBack}
          className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          Вернуться к списку
        </button>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden">
      {/* Header */}
      <div className="p-6 border-b border-slate-200">
        <button
          onClick={onBack}
          className="flex items-center gap-2 text-blue-600 hover:text-blue-700 mb-4 transition-colors"
        >
          <ArrowLeft className="w-5 h-5" />
          <span className="font-medium">Назад к списку</span>
        </button>

        <div className="flex items-start gap-4">
          <div className={`p-3 rounded-xl shadow-sm bg-${document.color}-100 text-${document.color}-600`}>
            <BookOpen className="w-6 h-6" />
          </div>
          <div className="flex-1">
            <h2 className="text-2xl font-bold text-slate-900 mb-2">{document.display_name}</h2>
            {document.description && (
              <p className="text-slate-600">{document.description}</p>
            )}
            <div className="flex items-center gap-4 mt-3 text-sm text-slate-500">
              {document.fileSizeMB && (
                <span>Размер: {document.fileSizeMB} МБ</span>
              )}
              {document.category && (
                <span className={`px-2 py-1 rounded bg-${document.color}-50 text-${document.color}-700 font-medium`}>
                  {document.category}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="p-8">
        <div
          className="prose prose-slate max-w-none
                     prose-headings:font-bold prose-headings:text-slate-900
                     prose-h1:text-3xl prose-h1:mb-4
                     prose-h2:text-2xl prose-h2:mb-3 prose-h2:mt-6
                     prose-h3:text-xl prose-h3:mb-2 prose-h3:mt-4
                     prose-p:text-slate-700 prose-p:leading-relaxed prose-p:mb-3
                     prose-ul:list-disc prose-ul:pl-6 prose-ul:mb-4
                     prose-ol:list-decimal prose-ol:pl-6 prose-ol:mb-4
                     prose-li:text-slate-700 prose-li:mb-2
                     prose-strong:font-semibold prose-strong:text-slate-900
                     prose-em:italic prose-em:text-slate-700
                     prose-table:w-full prose-table:border-collapse
                     prose-th:border prose-th:border-slate-300 prose-th:bg-slate-100 prose-th:px-4 prose-th:py-2 prose-th:text-left
                     prose-td:border prose-td:border-slate-200 prose-td:px-4 prose-td:py-2
                     prose-img:rounded-lg prose-img:shadow-md prose-img:mx-auto"
          dangerouslySetInnerHTML={{ __html: htmlContent }}
        />
      </div>

      {/* Footer */}
      <div className="p-4 bg-slate-50 border-t border-slate-200 flex justify-center">
        <button
          onClick={onBack}
          className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
        >
          Вернуться к списку
        </button>
      </div>
    </div>
  );
};

export default DocxViewer;
